import { Component } from '@angular/core';

@Component({
  selector: 'cms-show-more',
  templateUrl: './cms-show-more.component.html',
  standalone: false,
})
export class CmsShowMoreComponent {}
